module.exports = __webpack_public_path__ + "img/kf.dd6289b1.jpg";